"use strict";

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Transcriber =
/*#__PURE__*/
function () {
  function Transcriber(_module) {
    _classCallCheck(this, Transcriber);

    this.m_Module = new module_1.ModuleCode(_module);
    this.m_ClassMap = new Map();
    this.m_MethodMap = new Map();
    this.m_ContextMap = new Map();
    this.m_InlineContextMap = new Map();
    this.m_DSLMap = new Map();
    this.m_Plugins = new Array();
  }

  _createClass(Transcriber, [{
    key: "Transcribe",
    value: function Transcribe() {
      this.m_Plugins.forEach(function (plugin) {
        return plugin.Transcribe();
      });
      return utility_1.ToString(this.m_Module.m_File, {
        comments: false
      });
    }
  }, {
    key: "AddDSL",
    value: function AddDSL(name, dsl) {
      this.m_DSLMap.set(name, dsl);
    }
  }, {
    key: "GetDSL",
    value: function GetDSL(name) {
      return this.m_DSLMap.get(name);
    }
  }, {
    key: "GetLocalContext",
    value: function GetLocalContext(name) {
      return this.m_ContextMap.get(name);
    }
  }, {
    key: "TraverseLocalContext",
    value: function TraverseLocalContext(callback) {
      this.m_ContextMap.forEach(function (context, name) {
        return callback(context, name);
      });
    }
  }, {
    key: "TraverseInlineContext",
    value: function TraverseInlineContext(callback) {
      this.m_InlineContextMap.forEach(function (context) {
        return callback(context);
      });
    }
  }, {
    key: "GetClass",
    value: function GetClass(name) {
      return this.m_ClassMap.get(name);
    }
  }, {
    key: "TraverseMethod",
    value: function TraverseMethod(callback) {
      this.m_MethodMap.forEach(function (methods, class_name) {
        return callback(methods, class_name);
      });
    }
  }]);

  return Transcriber;
}();

exports.Transcriber = Transcriber;

var utility_1 = require("../common/utility");

var module_1 = require("../code-object/module");